// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3iy3u","header":"ReportDetails_header__Ku7Ns","title":"ReportDetails_title__26kkL","left":"ReportDetails_left__14jhM"};